export const tokens = {
  common: {
    languageChanged: 'common.languageChanged'
  },
  interface: {
    active: 'interface.active',
    add: 'interface.add',
    edit: 'interface.edit',
    delete: 'interface.delete',
    deleted: 'interface.deleted',
    addate: 'interface.addate',
    appusers: 'interface.appusers',
    contractType: 'interface.contractType',
    contractTypes: 'interface.contractTypes',
    ccaStaff: 'interface.ccaStaff',
    csStaff: 'interface.csStaff',
    awardamt: 'interface.awardamt',
    details: 'interface.details',
    view: 'interface.view',
    certifysublistrequest: 'interface.certifysublistrequest',
    dirno: 'interface.dirno',
    dirprojectno: 'interface.dirprojectno',
    estfinish: 'interface.estfinish',
    eststart: 'interface.eststart',
    notifications: 'interface.notifications',
    projectvendors: 'interface.projectvendors',
    psa: 'interface.psa',
    state: 'interface.state',
    psaimpact: 'interface.psaimpact',
    wagedetermination: 'interface.wagedetermination',
    inactive: 'interface.inactive',
    vendorname: 'interface.vendorname',
    dirclassification: 'interface.dirclassification',
    expires: 'interface.expires',
    effective: 'interface.effective',
    cslbno: 'interface.cslbno',
    contractsearch: 'interface.contractsearch',
    activecontractsearch: 'interface.activecontractsearch',
    contractsearchhidden: 'interface.contractsearchhidden',
    contract: 'interface.contract',
    registeredsubs: 'interface.registeredsubs',
    generalcontractor: 'interface.generalcontractor',
    createcertifysublist: 'interface.createcertifysublist',
    createcertifysublistdate: 'interface.createcertifysublistdate',
    send: 'interface.send',
    certifymessage: 'interface.certifymessage',
    inactivatevendormessage: 'interface.inactivatevendormessage',
    message: 'interface.message',
    set: 'interface.set',
    inactivatevendorinstructions: 'interface.inactivatevendorinstructions',
    messageandsave: 'interface.messageandsave',
    vendor: 'interface.vendor',
    save: 'interface.save',
    cancel: 'interface.cancel',
    contactemail: 'interface.contactemail',
    address: 'interface.address',
    address1: 'interface.address1',
    address2: 'interface.address2',
    address3: 'interface.address3',
    licenses: 'interface.licenses',
    licno: 'interface.licno',
    pwcclassification: 'interface.pwcclassification',
    vendorregistration: 'interface.vendorregistration',
    editclassifications: 'interface.editclassifications',
    information: 'interface.information',
    refresh: 'interface.refresh',
    dir: 'interface.dir',
    cslb: 'interface.cslb',
    id: 'interface.id',
    lastverified: 'interface.lastverified',
    registrations: 'interface.registrations',
    projectvendor: 'interface.projectvendor',
    projectvendorinactivemessage: 'interface.projectvendorinactivemessage',
    date: 'interface.date',
    verified: 'interface.verified',
    verificationhistory: 'interface.verificationhistory',
    verificationpdf: 'interface.verificationpdf',
    awardon: 'interface.awardon',
    bidsearch: 'interface.bidsearch',
    activebidsearch: 'interface.activebidsearch',
    bidno: 'interface.bidno',
    open: 'interface.open',
    name: 'interface.name',
    poundSign: 'interface.poundSign',
    createdate: 'interface.createdate',
    bidsearchhidden: 'interface.bidsearchhidden',
    vendorsearchmessage: 'interface.vendorsearchmessage',
    search: 'interface.search',
    vendorsearchhelptext: 'interface.vendorsearchhelptext',
    actions: 'interface.actions',
    action: 'interface.action',
    reset: 'interface.reset',
    dirclassificationused: 'interface.dirclassificationused',
    projectcount: 'interface.projectcount',
    project: 'interface.project',
    assignedon: 'interface.assignedon',
    dirclassifications: 'interface.dirclassifications',
    projectassignments: 'interface.projectassignments',
    notification: 'interface.notification',
    notificationdetail: 'interface.notificationdetail',
    completedon: 'interface.completedon',
    completedby: 'interface.completedby',
    viewedby: 'interface.seenon',
    certificationdetail: 'interface.certificationdetail',
    certifyinstruction1: 'interface.certifyinstruction1',
    certifyinstruction2: 'interface.certifyinstruction2',
    certifyinstruction3: 'interface.certifyinstruction3',
    certifyinstructionunderstand: 'interface.certifyinstructionunderstand',
    instructions: 'interface.instructions',
    certifycomplete: 'interface.certifycomplete',
    on: 'interface.on',
    requestedon: 'interface.requestedon',
    requestedby: 'interface.requestedby',
    comments: 'interface.comments',
    addnewsub: 'interface.addnewsub',
    currentsublist: 'interface.currentsublist',
    modify: 'interface.modify',
    removesubmessage: 'interface.removesubmessage',
    modifyassignment: 'interface.modifyassignment',
    completed: 'interface.completed',
    current: 'interface.current',
    addsubtitle: 'interface.addsubtitle',
    searchforvendor: 'interface.searchforvendor',
    searchforgeneralcontractor: 'interface.searchforgeneralcontractor',
    searchforvendorinstruction: 'interface.searchforvendorinstruction',
    noresultsmessage: 'interface.noresultsmessage',
    select: 'interface.select',
    addassignment: 'interface.addassignment',
    saveprogress: 'interface.saveprogress',
    completeandcertify: 'interface.completeandcertify',
    modifications: 'interface.modifications',
    confirmcancel: 'interface.confirmcancel',
    viewbid: 'interface.viewbid',
    saved: 'interface.saved',
    error: 'interface.error',
    unsavedwarning: 'interface.unsavedwarning',
    discardchanges: 'interface.discardchanges',
    districtprojectno: 'interface.districtprojectno',
    districtprojectnohelptext: 'interface.districtprojectnohelptext',
    projectsystem: 'interface.projectsystem',
    boardawarddate: 'interface.boardawarddate',
    done: 'interface.done',
    bidclosed: 'interface.bidclosed',
    notfound: 'interface.notfound',
    estamount: 'interface.estamount',
    addbidresponse: 'interface.addbidresponse',
    bids: 'interface.bids',
    bidamount: 'interface.bidamount',
    nonresponsivebid: 'interface.nonresponsivebid',
    marknonresponsivebid: 'interface.marknonresponsivebid',
    editbid: 'interface.editbid',
    replacegc: 'interface.replacegc',
    awardthis: 'interface.awardthis',
    created: 'interface.created',
    remove: 'interface.remove',
    additions: 'interface.additions',
    selections: 'interface.selections',
    removefrombid: 'interface.removefrombid',
    removefrombidmessage: 'interface.removefrombidmessage',
    confirm: 'interface.confirm',
    removed: 'interface.removed',
    viewcontract: 'interface.viewcontract',
    marknonresponsivebidmessage: 'interface.marknonresponsivebidmessage',
    selectclassifications: 'interface.selectclassifications',
    awardandclose: 'interface.awardandclose',
    awardandopen: 'interface.awardandopen',
    awardandclosemessage: 'interface.awardandclosemessage',
    awardandopenmessage: 'interface.awardandopenmessage',
    backgroundrefresh: 'interface.backgroundrefresh',
    activemessage: 'interface.activemessage',
    inactivemessage: 'interface.inactivemessage',
    dbanames: 'interface.dbanames',
    dbanamestitle: 'interface.dbanamestitle',
    close: 'interface.close',
    dbanamepreferredmessage: 'interface.dbanamepreferredmessage',
    preferred: 'interface.preferred',
    ignore: 'interface.ignore',
    ignoremessage: 'interface.ignoremessage',
    dirregname: 'interface.dirregname',
    zip: 'interface.zip',
    city: 'interface.city',
    certifylist: 'interface.certifylist',
    awardsuccess: 'interface.awardsuccess',
    deletebidmessage: 'interface.deletebidmessage'
  },
  nav: {
    home: 'nav.home',
    account: 'nav.account',
    admin: 'nav.admin',
    bidlist: 'nav.bidlist',
    biddetail: 'nav.biddetail',
    bidnew: 'nav.bidnew',
    contractlist: 'nav.contractlist',
    contractdetail: 'nav.contractdetail',
    contractnew: 'nav.contractnew',
    vendorsearch: 'nav.vendorsearch',
    vendordetail: 'nav.vendordetail',
    vendorassignmentdetail: 'nav.vendorassignmentdetail',
    reports: 'nav.reports',
    reportdesigner: 'nav.reportdesigner',
    appusers: 'nav.appusers',
    appuserdetail: 'nav.appuserdetail',
    approles: 'nav.approles',
    appsettings: 'nav.appsettings',
    notifications: 'nav.notifications',
    list: 'nav.list',
    pwm: 'nav.pwm',
    certificationdetail: 'nav.certificationdetail'

  }
};
